/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-rounded-down': {
    width: 5.4,
    height: 4.9,
    viewBox: '0 0 5.4 4.9',
    data: '<path pid="0" d="M1 0C.3 0-.2.8.2 1.4l1.7 3a1 1 0 001.7 0l1.7-3A1 1 0 004.4 0H1z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/arrow-rounded-down.js